import { invokeApi } from "../../bl_libs/invokeApi";

export const _get_home_settings_admin = async (data) => {
    const requestObj = {
      path: `api/website_settings/get_home_settings_admin`,
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    return invokeApi(requestObj);
  };
  export const _add_home_settings_admin = async (data) => {
    const requestObj = {
        path: `api/website_settings/add_home_settings_admin`,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
      postData: data,
    };
    return invokeApi(requestObj);
  };